import { useCallback } from 'react';
import useApiCall from './useApiCall';
import getJobsFaxCounters from '../services/getJobsFaxCounters';
import getJobsPrintCounters from '../services/getJobsPrintCounters';
import getJobsScanCounters from '../services/getJobsScanCounters';
import getJobsPrintAreaCounters from '../services/getJobsPrintAreaCounters';

function useJobTelemetryApiCall({
  authProvider,
  stack,
  params,
}) {
  const fetchFaxCounter = useCallback(
    ({ startDate, endDate }) => getJobsFaxCounters(
      {
        stack, authProvider, startDate, endDate,
      },
    ),
    [authProvider, stack],
  );
  const faxCounterCall = useApiCall({
    initialData: null,
    apiCall: fetchFaxCounter,
    params,
  });

  const fetchPrintCounter = useCallback(
    ({ startDate, endDate }) => getJobsPrintCounters({
      stack, authProvider, startDate, endDate,
    }),
    [authProvider, stack],
  );
  const printCounterCall = useApiCall({
    initialData: null,
    apiCall: fetchPrintCounter,
    params,
  });

  const fetchScanCounter = useCallback(
    ({ startDate, endDate }) => getJobsScanCounters(
      {
        stack, authProvider, startDate, endDate,
      },
    ),
    [authProvider, stack],
  );
  const scanCounterCall = useApiCall({
    initialData: null,
    apiCall: fetchScanCounter,
    params,
  });

  const fetchPrintAreaCounter = useCallback(
    ({ startDate, endDate }) => getJobsPrintAreaCounters({
      stack, authProvider, startDate, endDate,
    }),
    [authProvider, stack],
  );

  const printAreaCounterCall = useApiCall({
    initialData: null,
    apiCall: fetchPrintAreaCounter,
    params,
  });

  const data = {
    print: printCounterCall,
    printArea: printAreaCounterCall,
    scan: scanCounterCall,
    fax: faxCounterCall,
  };

  const pending = printCounterCall.pending
               || printAreaCounterCall.pending
               || scanCounterCall.pending
               || faxCounterCall.pending;

  const success = printCounterCall.success
               || printAreaCounterCall.success
               || scanCounterCall.success
               || faxCounterCall.success;

  const error = printCounterCall.error
             || printAreaCounterCall.error
             || scanCounterCall.error
             || faxCounterCall.error;

  const allRequestsFailed = printCounterCall.error
             && printAreaCounterCall.error
             && scanCounterCall.error
             && faxCounterCall.error;

  const makeApiCall = useCallback(args => {
    printCounterCall.makeApiCall(args);
    printAreaCounterCall.makeApiCall(args);
    scanCounterCall.makeApiCall(args);
    faxCounterCall.makeApiCall(args);
  }, [
    printCounterCall,
    printAreaCounterCall,
    scanCounterCall,
    faxCounterCall,
  ]);

  return {
    allRequestsFailed,
    data,
    pending,
    error,
    success,
    makeApiCall,
  };
}

export default useJobTelemetryApiCall;
